/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeCancelCategory } from './exchange-cancel-category';
// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeManagementUser } from './exchange-management-user';
// May contain unused imports in some cases
// @ts-ignore
import type { ExposeBankAccount } from './expose-bank-account';

/**
 * 
 * @export
 * @interface AdminGetExchangeDataResponseDto
 */
export interface AdminGetExchangeDataResponseDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exchangeUuid': string;
    /**
     * 환급 신청 금액
     * @type {number}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'amountRequested': number;
    /**
     * 환급 신청 전 환급 가능 금액
     * @type {number}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exchangeableAmountBeforeRequest': number;
    /**
     * 잔액
     * @type {number}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'balance': number;
    /**
     * 환급 예정 금액
     * @type {number}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'amountBeExchanged': number;
    /**
     * 세금
     * @type {number}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'tax': number;
    /**
     * 환급 상태
     * @type {string}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'status': AdminGetExchangeDataResponseDtoStatusEnum;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'createdAt': string;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exchangeCancelOtherReason': string;
    /**
     * 환급 (예정) 일시
     * @type {string}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exchangeAt': string;
    /**
     * 취소 여부
     * @type {boolean}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'isCancelled': boolean;
    /**
     * 환급 불가 사유
     * @type {ExchangeCancelCategory}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exchangeCancelCategory': ExchangeCancelCategory;
    /**
     * 노출용 계좌 정보
     * @type {ExposeBankAccount}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exposeBankAccount': ExposeBankAccount;
    /**
     * 노출용 환급 관리되는 유저
     * @type {ExchangeManagementUser}
     * @memberof AdminGetExchangeDataResponseDto
     */
    'exchangeManagementUser': ExchangeManagementUser;
}

export const AdminGetExchangeDataResponseDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type AdminGetExchangeDataResponseDtoStatusEnum = typeof AdminGetExchangeDataResponseDtoStatusEnum[keyof typeof AdminGetExchangeDataResponseDtoStatusEnum];


